import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetCheckIfSuperAdmin() {

    var url = "/class_app/check_if_super_admin";

    return FetchGetDataWithAuthNEW(url);
}

